import { useGetCryptoDepositProductsQuery } from 'store/slices/deposits-api';

export function useCryptoDepositProduct(code?: string) {
  const { data: cryptoDepositProducts } = useGetCryptoDepositProductsQuery();
  if (!code) return undefined;
  return cryptoDepositProducts?.find?.(
    p => p?.code.toUpperCase() == code.toUpperCase(),
  );
}
